<template>
  <el-dialog
    title="預覽"
    :visible.sync="mIsShow"
    append-to-body
    width="592px"
    height="500px">
    <span>
      <iframe
        v-if="mIsShow"
        :src="`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D${previewingPostID}%26id%3D${fansPageNumID}`"
        width="100%"
        height="600"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media">
      </iframe>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    previewingPostID: {
      type: String
    },
    fansPageID: {
      type: String,
      required: true
    },
    fansPageNumID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mIsShow: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
    }
  }
}
</script>
